// This code is used in the dropdown menu (it is used across pages) and my sidebar
$(document).on("turbo:load", () => {
  const inboxMessageCounters = $(".unread-inbox-count")
  const sampleCount = parseInt(inboxMessageCounters.first().html())
  if (sampleCount > 0) inboxMessageCounters.show()
})
